<template lang='pug'>
  .bf-offer.component(@click='$router.push("/profile/true")')
    p {{ $t('Free first month access to our business section!') }}
    p {{ $t('Six months money-back guarantee.  No questions asked!') }}
    p {{ $t('Only $30 per month for full features and benefits') }}
    bf-button.text-only
      template(v-slot:text) {{ $t('Activate Business Function') }}
</template>

<script>
  export default {
    name: 'bf-offer'
  }
</script>

<style scoped lang='stylus'>
  .bf-offer
    line-height 1.5
    font-size .88em
    text-align center
    background rgb( 255 200 100 )
    padding 16px
    margin-top 16px
    border-radius 5px
    .bf-button
      margin 0 auto
      margin-top 16px
      background rgb( 75 175 240 )
      font-size 1.25em
      font-weight bold
      color white
</style>
